const LICENSE_EXPIRY = {id: 1, priority: 1, name: 'License Renewal'}
const ECHANNEL_EXPIRY = {id: 2, priority: 2, name: 'E-channel Renewal'}
const CARD_EXPIRY = {id: 3, priority: 3, name: 'Establishment Card Renewal'}
const OFFICE_LEASE_EXPIRY = {id: 4, priority: 4, name: 'Office Lease Renewal'}
const APARTMENT_LEASE_EXPIRY = {id: 5, priority: 5, name: 'Apartment Lease Renewal'}
const VISA_EXPIRY = {id: 6, priority: 6, name: 'Visa Renewal'}

const expireCategoriesForServiceForm = [
  LICENSE_EXPIRY,
  APARTMENT_LEASE_EXPIRY,
  VISA_EXPIRY
]
export {
  expireCategoriesForServiceForm,
  LICENSE_EXPIRY,
  ECHANNEL_EXPIRY,
  CARD_EXPIRY,
  OFFICE_LEASE_EXPIRY,
  APARTMENT_LEASE_EXPIRY,
  VISA_EXPIRY
}



// WEBPACK FOOTER //
// ./src/constants/expireCategories.js